import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./Slice/Auth/AuthSlice";
import albumSlice from "./Slice/Dashboard/AlbumSlice";
import folderSlice from "./Slice/Dashboard/FolderSlicer";
import memberSlice from "./Slice/Dashboard/MemberSlice";
import extraSlice from "./Slice/Dashboard/ExtraSlice";
import eventSlice from "./Slice/Dashboard/EventSlice";
import PackageSlice from "./Slice/Dashboard/PackageSlice";
import PaymentSlice from "./Slice/Dashboard/PaymentSlice";
import FlagSlice from "./Slice/Dashboard/FlagSlice";
import QuotationSlice from "./Slice/Dashboard/QuotationSlice";
import CustomerTransactionSlice from "./Slice/Dashboard/CustomerTransaction";
import TeamMemberPaymentSlice from "./Slice/Dashboard/TeamMemberPaymentSlice";
import whatsAppSlice from "./Slice/Dashboard/WhatsAppSlice";
import orderSlice from "./Slice/Dashboard/OrderSlice";
import invoiceSlice from "./Slice/Dashboard/InvoiceSlice";
import marketplaceSlice from "./Slice/Dashboard/MarketplaceSlice";
import roleSlice from "./Slice/Dashboard/RoleSlice";
const store = configureStore({
  reducer: {
    auth: authSlice,
    album: albumSlice,
    folder: folderSlice,
    member: memberSlice,
    extra: extraSlice,
    event: eventSlice,
    package: PackageSlice,
    payment: PaymentSlice,
    flags: FlagSlice,
    quotation: QuotationSlice,
    customer_transaction: CustomerTransactionSlice,
    teamMemberPayment: TeamMemberPaymentSlice,
    whatsapp: whatsAppSlice,
    order: orderSlice,
    invoice: invoiceSlice,
    marketplace: marketplaceSlice,
    role: roleSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
